import { useCallback, useState } from 'react';
import { INITIAL_FILTERS } from 'features/IRWorkstation/components/Fundraising/FundraisingFilters';

const FILTERS_STORAGE_KEY = 'fundraisingPipeline:filters';

// Only known filter keys with string values are restored, so a stale or corrupt
// entry can never send an unexpected filter to the API.
const readStoredFilters = () => {
	try {
		const stored = JSON.parse(localStorage.getItem(FILTERS_STORAGE_KEY));

		if (!stored || typeof stored !== 'object') return INITIAL_FILTERS;

		return Object.keys(INITIAL_FILTERS).reduce(
			(filters, key) => ({
				...filters,
				[key]:
					typeof stored[key] === 'string' ? stored[key] : INITIAL_FILTERS[key],
			}),
			{}
		);
	} catch {
		return INITIAL_FILTERS;
	}
};

const hasActiveFilters = (filters) =>
	Object.values(filters).some((value) => value !== '');

// Filter state for the LP Pipeline table. Persisted in localStorage, like the
// table sort, so it survives navigating to an LP360 page and back.
const useFundraisingFilters = () => {
	const [filters, setFiltersState] = useState(readStoredFilters);

	const setFilters = useCallback((next) => {
		setFiltersState(next);

		if (hasActiveFilters(next)) {
			localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(next));
		} else {
			localStorage.removeItem(FILTERS_STORAGE_KEY);
		}
	}, []);

	return { filters, setFilters };
};

export { FILTERS_STORAGE_KEY };
export default useFundraisingFilters;
